export enum InteractionEnum {
    DEFAULT
}
